// extracted by mini-css-extract-plugin
export var customCol = "multi-column-content-module--customCol--58bf3";
export var customGrid = "multi-column-content-module--customGrid--b934a";
export var dark = "multi-column-content-module--dark--7b43a";
export var heading = "multi-column-content-module--heading--c816e";
export var root = "multi-column-content-module--root--00f2b";